import { selectCoverOptions } from '../selectors/selectCoverOptions';
import { useGetDynamicCoversQuery } from '../services/refData';
import { utcDateFormatter } from '../utils';
import { useAppSelector, useBusinessDetails } from './useSelectors';

export function useCoverOptions() {
  const { industry, coverStart } = useBusinessDetails();
  const mappedCovers = useAppSelector(selectCoverOptions);
  const { error, isLoading, isFetching } = useGetDynamicCoversQuery({
    industryCode: industry?.industryCode || '00',
    effectiveDate: utcDateFormatter(coverStart!),
  });
  return { data: mappedCovers, error, isLoading, isFetching };
}

export type CoverOptions = NonNullable<ReturnType<typeof useCoverOptions>['data']>;
